import { Routes } from '@angular/router';
import { HomeComponent } from './selfservice/pages/home/home.component';

/**
 * Rutas de la aplicación
 */
export const APP_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'selfservice',
    pathMatch: 'full'
  },
  {
    path: 'selfservice',
    children: [
      {
        path: '',
        title: 'Identificación',
        loadComponent: () =>
          import('./selfservice/pages/home/home.component').then(
            (c) => c.HomeComponent
          )
      },
      {
        path: 'mfa-selection',
        title: 'Selección MFA',
        loadComponent: () =>
          import('./selfservice/pages/mfa-selection/mfa-selection.component').then(
            (c) => c.MfaSelectionComponent
          )
      },
      {
        path: 'biometric/start',
        title: 'Validación Biométrica',
        loadComponent: () =>
          import('./selfservice/pages/biometric-start/biometric-start.component').then(
            (c) => c.BiometricStartComponent
          )
      },
      {
        path: 'biometric/result',
        title: 'Resultado Biométrico',
        loadComponent: () =>
          import('./selfservice/pages/biometric-result/biometric-result.component').then(
            (c) => c.BiometricResultComponent
          )
      },
      {
        path: 'biometric/complete',
        title: 'Completando Verificación',
        loadComponent: () =>
          import('./selfservice/pages/biometric-complete/biometric-complete.component').then(
            (c) => c.BiometricCompleteComponent
          )
      },
      {
        path: 'biometric/totp-registration',
        title: 'Registro TOTP',
        loadComponent: () =>
          import('./selfservice/pages/biometric-totp-registration/biometric-totp-registration.component').then(
            (c) => c.BiometricTotpRegistrationComponent
          )
      }
    ]
    //loadChildren: () =>
    //import('./selfservice/selfservice.routes').then((s) => s.SelfServiceRoutes)
  }
];
